import { render, staticRenderFns } from "./PrintQuestionsTitle.vue?vue&type=template&id=f8f235e8&"
import script from "./PrintQuestionsTitle.vue?vue&type=script&lang=js&"
export * from "./PrintQuestionsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports